import React from "react";

function BrandingBadge() {
  return null;
}

export default BrandingBadge;